import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import nwsFetch from './customFetch.js';
import {Submit} from './Fields.js';

export function Subscription(){
  const [plans, setPlans] = useState([]);
  const [currentPlan, setCurrentPlan] = useState("");
  const [billingUrl, setBillingUrl] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    nwsFetch(
      "/api/plans/", {}
    ).then(async (response) => {
      if(response.ok){
        const plans = await response.json();
        setPlans(plans.results);
        setLoading(false);
      }
    });
  }, []);
  useEffect(() => {
    nwsFetch(
      "/api/subscription/", {}
    ).then(async (response) => {
      if(response.ok){
        const customer = await response.json();
        if(customer.subscription_plan){
          setCurrentPlan(customer.subscription_plan);
          setBillingUrl(customer.billing_portal_url);
        }else{
          setCurrentPlan("");
        }
        setLoading(false);
      }
    });
  }, []);
  if(loading){
    return null;
  }
  async function onSubmit(){
    const response = await nwsFetch(
      "/api/subscription/", {
        method: "POST",
        body: JSON.stringify({
          subscription_plan: currentPlan,
          quantity: 1
        }),
      }
    ); 
    if(response.ok){
      const customer = await response.json();
      window.location.href = customer.redirect_url;
    }
  }
  let bottom;
  if(billingUrl){
    bottom = (
      <Link href={billingUrl}>Manage subcsription at Stripe</Link>
    );
  }else{
    bottom = (
      <Submit
        onSubmit={onSubmit}
        error={{}}
        name="Subscribe (You will be redirected to stripe)"
      />
    );
  }
  function getHumanReadableLimit(plan){
    if(plan.nesting_minutes_monthly_limit){
      return plan.nesting_minutes_monthly_limit;
    }else{
      return "Unlimited";
    }
  }
  return (
		<Container maxWidth="sm">
			<Box component="form">
        <FormControl fullWidth>
          <InputLabel id="subscription_plan_label">Subscription plan</InputLabel>
          <Select
            labelId="subscription_plan_label"
            id="subscription_plan"
            value={currentPlan}
            disabled={Boolean(billingUrl)}
            onChange={(evt) => setCurrentPlan(evt.target.value)}
          >
            <MenuItem value={""}>No Subscription</MenuItem>
            {plans.map((plan) => (<MenuItem key={plan.name} value={plan.id}>{plan.name}</MenuItem>))}
          </Select>
        </FormControl>
        {bottom}   
			</Box>
      <TableContainer component={Paper} sx={{marginTop: 2}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Plan</TableCell>
              <TableCell>Nesting time limit (minutes / month)</TableCell>
              <TableCell>Storage (GB)</TableCell>
              <TableCell>Base Price (€ / month)</TableCell>
              <TableCell>Additional nesting user (€ / month)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {plans.map((plan) => (
              <TableRow key={plan.name}>
                <TableCell>{plan.name}</TableCell>
                <TableCell>{getHumanReadableLimit(plan)}</TableCell>
                <TableCell>{plan.design_gb_mo_limit}</TableCell>
                <TableCell>{plan.amount_cents / 100}</TableCell>
                <TableCell>{plan.amount_cents_seat / 100}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
		</Container>
  )
}
